<template>
  <el-dialog
      v-model="visible"
      width="70vw"
      :close-on-click-modal="true"
      :destroy-on-close="true"
      :z-index="99"
      top="4em"
      modal-class="media-docs-links-dialog-overlay"
      class="media-docs-links-dialog"
      style="max-height:85vh;height:auto;z-index:99 !important;"
  >
    <template #header>
      <div class="dialog-header">
        <span class="dialog-title">{{ $t('whatsapp.drawer.mediaDocsLinks') }}</span>
      </div>
    </template>

    <div class="dialog-body">
      <el-tabs v-model="activeTab" class="demo-tabs">
        <el-tab-pane :label="$t('whatsapp.mediaDocsLinks.tabs.media')" name="media">
          <el-table
              :data="tableData"
              v-loading="loading"
              :cell-style="rowClassName"
              :header-cell-style="headerClassName"
              style="width: 100%;max-height: 55vh;">
            <el-table-column prop="content" :label="$t('whatsapp.mediaDocsLinks.table.content')">
              <template #default="{ row }">
                <!-- <div class="media-cell"> -->
                  <img
                      v-if="row?.mediaUrl"
                      class="media-thumb"
                      :src="row.mediaUrl"
                      loading="lazy"
                      decoding="async"
                      @click="handlePreviewImage(row)"
                  />
                  <!-- <span class="media-url">{{ row?.mediaUrl || '—' }}</span> -->
                <!-- </div> -->
              </template>
            </el-table-column>
            <el-table-column prop="description" :label="$t('whatsapp.mediaDocsLinks.table.description')">
              <template #default="{ row }">
                <span>{{ row?.mediaName || '—' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sender" :label="$t('whatsapp.mediaDocsLinks.table.sender')">
              <template #default="{row}">
                <div style="display: flex;justify-content: center;align-items:center">
                  <div><img style="width: 36px;height: 36px;border-radius: 50%" :src="resolveSenderPicture(row)"/></div>
                  <div style="display: flex;flex-direction: column;align-items: flex-start;margin-left: 2px;">
                    <span class="username">{{ row.sender.username }}</span>
                    <span class="time">{{ row.sender.time }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column>
              <template #default="{ row }">
              <button class="action-btn" type="button" :aria-label="$t('whatsapp.mediaDocsLinks.delete')" @click="handleDeleteRow(row)">
                <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/delete.png"/>
              </button>
              <button class="action-btn" type="button" :aria-label="$t('whatsapp.mediaDocsLinks.forward')" @click="handleForwardRow(row)">
                <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/forword.png"/>
              </button>
              <button
                  v-if="activeTab !== 'links'"
                  class="action-btn"
                  type="button"
                  :aria-label="$t('whatsapp.mediaDocsLinks.download')"
                  @click="handleDownloadRow(row)"
              >
                <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/download.png"/>
              </button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('whatsapp.mediaDocsLinks.tabs.docs')" name="docs">
          <el-table
              :data="tableData"
              v-loading="loading"
              :cell-style="rowClassName"
              :header-cell-style="headerClassName"
              style="width: 100%;max-height: 55vh;">
            <el-table-column prop="content" :label="$t('whatsapp.mediaDocsLinks.table.content')">
              <template #default="{ row }">
                <div class="doc-brief" @dblclick="handlePreviewDoc(row)">
                  <div class="doc-brief__icon">
                    <FileIcon
                        :fileExtend="getFileExtFromNameOrUrl(row?.docName, row?.docUrl)?.toLocaleLowerCase()"
                        :fileUrl="row?.docUrl"
                        :size="35"
                        :isAbbreviation="true"
                    ></FileIcon>
                  </div>
                  <div class="doc-brief__text">
                    <div class="doc-brief__title">{{ row?.docName || '—' }}</div>
                    <div class="doc-brief__sub">
                      {{ (getFileExtFromNameOrUrl(row?.docName, row?.docUrl) || '').toUpperCase() }}·{{ getFileSize(row?.raw?.extendSize || row?.raw?.size || 0) }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="description" :label="$t('whatsapp.mediaDocsLinks.table.description')">
              <template #default="{ row }">
                <span>{{ row?.docName || '—' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sender" :label="$t('whatsapp.mediaDocsLinks.table.sender')">
              <template #default="{row}">
                <div style="display: flex;justify-content: center;align-items:center">
                  <div><img style="width: 35px;height: 35px;border-radius: 50%" :src="resolveSenderPicture(row)"/></div>
                  <div style="display: flex;flex-direction: column;align-items: flex-start;margin-left: 2px;">
                    <span class="username">{{ row.sender.username }}</span>
                    <span class="time">{{ row.sender.time }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column>
              <template #default="{ row }">
              <button class="action-btn" type="button" :aria-label="$t('whatsapp.mediaDocsLinks.delete')" @click="handleDeleteRow(row)">
                <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/delete.png"/>
              </button>
              <button class="action-btn" type="button" :aria-label="$t('whatsapp.mediaDocsLinks.forward')" @click="handleForwardRow(row)">
                <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/forword.png"/>
              </button>
              <button
                  v-if="activeTab !== 'links'"
                  class="action-btn"
                  type="button"
                  :aria-label="$t('whatsapp.mediaDocsLinks.download')"
                  @click="handleDownloadRow(row)"
              >
                <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/download.png"/>
              </button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('whatsapp.mediaDocsLinks.tabs.links')" name="links">
          <el-table
              :data="tableData"
              v-loading="loading"
              :cell-style="rowClassName"
              :header-cell-style="headerClassName"
              style="width: 100%;max-height: 55vh;">
            <el-table-column prop="content" :label="$t('whatsapp.mediaDocsLinks.table.content')">
              <template #default="{ row }">
                <div class="link-brief" @dblclick.stop="handlePreviewLink(row)">
                  <div class="link-brief__icon">
                    <img
                        class="link-favicon"
                        :src="getFaviconUrl(row?.content || row?.url)"
                        alt=""
                        @error="handleFaviconError"
                    />
                  </div>
                  <div class="link-brief__text">
                    <div class="link-brief__title">链接</div>
                    <div class="link-brief__sub">{{ getLinkHost(row?.content || row?.url) }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="description" :label="$t('whatsapp.mediaDocsLinks.table.description')"/>
            <el-table-column prop="sender" :label="$t('whatsapp.mediaDocsLinks.table.sender')">
              <template #default="{row}">
                <div style="display: flex;justify-content: center;align-items:center">
                  <div><img style="width: 35px;height: 35px;border-radius: 50%" :src="resolveSenderPicture(row)"/></div>
                  <div style="display: flex;flex-direction: column;align-items: flex-start;margin-left: 2px;">
                    <span class="username">{{ row.sender.username }}</span>
                    <span class="time">{{ row.sender.time }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column>
              <template #default="{ row }">
              <button class="action-btn" type="button" :aria-label="$t('whatsapp.mediaDocsLinks.delete')" @click="handleDeleteRow(row)">
                <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/delete.png"/>
              </button>
              <button class="action-btn" type="button" :aria-label="$t('whatsapp.mediaDocsLinks.forward')" @click="handleForwardRow(row)">
                <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/forword.png"/>
              </button>
              <button
                  v-if="activeTab !== 'links'"
                  class="action-btn"
                  type="button"
                  :aria-label="$t('whatsapp.mediaDocsLinks.download')"
                  @click="handleDownloadRow(row)"
              >
                <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/download.png"/>
              </button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <ForwardMessage ref="forwardMessage" @send="handleForwardSend" @close="handleForwardClose" />

      <div style="display: flex;justify-content: flex-end;margin-top: 12px;">
        <el-pagination
        size="small"
            v-if="total > 0"
            v-model:current-page="pageNo"
            :page-size="pageSize"
            :total="total"
            layout="total, prev, pager, next, jumper"
            @current-change="handleCurrentChange"
        />
      </div>

      <div class="table_box" style="width: 100%;display: flex;justify-content: center;margin-top: 10px;">
        <div>{{ $t('whatsapp.mediaDocsLinks.dialog.recentOnly') }}</div>
        <div>{{ $t('whatsapp.mediaDocsLinks.dialog.findEarlier') }}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import MediaDocsLinksPanel from './panels/MediaDocsLinksPanel.vue'
import {ElMessageBox, ElTable} from "element-plus";
import {addWhatsAppExtend, deleteWhatsAppExtendBatch, getWhatsAppExtendList, sendFile, sendImage, sendLinkCustomPreview, sendText} from "@/api/whatsapp";
import {Storage} from "@/utils/storage";
import FileIcon from "@/components/File/FileIcon.vue";
import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'
import ForwardMessage from "@/views/WhatsApp/Compontents/ForwardMessage.vue";
import { downloadFile } from "@/utils/file";
import defaultUserAvatar from '@/modules/whatsapp/img/default_user_avatar.svg'

export default {
  name: 'MediaDocsLinksDialog',
  components: {ElTable, MediaDocsLinksPanel, FileIcon, ForwardMessage},
  props: {
    modelValue: {type: Boolean, default: false},
    defaultTab: {
      type: String,
      default: 'media',
      validator: (v) => ['media', 'docs', 'links'].includes(v)
    },
    // When true, query all attachments; otherwise can be scoped by chatId (if provided).
    isAllMode: {type: Boolean, default: false},
    chatId: {type: String, default: ''},
    mediaList: {type: Array, default: () => []},
    docsList: {type: Array, default: () => []},
    linksList: {type: Array, default: () => []}
  },
  emits: ['update:modelValue', 'preview-media', 'delete', 'forward', 'download'],
  data() {
    return {
      activeTab: this.defaultTab || 'media',
      tableData: [],
      loading: false,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      forwardRow: null
    }
  },
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(v) {
        this.$emit('update:modelValue', v)
      }
    }
  },
  watch: {
    defaultTab: {
      immediate: true,
      handler(val) {
        if (val && ['media', 'docs', 'links'].includes(val)) {
          this.activeTab = val
        }
      }
    },
    modelValue(val) {
      if (val) {
        this.activeTab = this.defaultTab || 'media'
        this.resetPagination()
        this.fetchList()
      }
    },
    activeTab() {
      if (!this.visible) return
      this.resetPagination()
      this.fetchList()
    }
  },
  methods: {
    resolveSenderPicture(row) {
      const pic = row?.sender?.picture || row?.sender?.avatar || row?.sender?.avatarUrl || ''
      if (typeof pic === 'string' && pic.trim()) return pic
      return defaultUserAvatar
    },
    rowClassName({row, column, rowIndex, columnIndex}) {
      // console.log(row, columnIndex)
      const prop = column?.property || column?.prop
      if (prop === 'content') {
        return { textAlign: 'left', fontSize: '13px' }
      }
      return { textAlign: 'center', fontSize: '13px' }
    },
    getFileSize(size) {
      const n = Number(size || 0)
      if (!Number.isFinite(n) || n <= 0) return '未知大小'
      const kb = n / 1024
      if (kb < 1024) {
        return `${Math.max(1, Math.round(kb))}kb`
      }
      const mb = kb / 1024
      if (mb < 1024) {
        return `${mb.toFixed(1)}mb`
      }
      const gb = mb / 1024
      return `${gb.toFixed(1)}gb`
    },
    getFileExtFromNameOrUrl(name, url) {
      const n = String(name || '').trim()
      if (n && n.includes('.')) {
        const ext = n.split('.').pop()
        return String(ext || '').toLowerCase()
      }
      const u = String(url || '').split('?')[0].split('#')[0].trim()
      if (!u) return ''
      const last = u.lastIndexOf('.')
      if (last === -1) return ''
      return u.slice(last + 1).toLowerCase()
    },
    normalizeLinkUrl(s) {
      const str = String(s || '').trim()
      if (!str) return ''
      if (/^(javascript|data|vbscript):/i.test(str)) return ''
      if (/[^\S\r\n]/.test(str)) return ''
      if (str.startsWith('http://') || str.startsWith('https://')) return str
      const domainLike = /^[a-zA-Z0-9.-]+(?::\d+)?(?:\/.*)?$/.test(str)
      if (!domainLike) return ''
      return `https://${str}`
    },
    isOfficePreviewableExt(ext) {
      const e = String(ext || '').toLowerCase()
      return ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(e)
    },
    handlePreviewDoc(row) {
      const target = row || {}
      const url = String(target?.docUrl || target?.raw?.url || target?.raw?.extendUrl || target?.raw?.fileUrl || '').trim()
      if (!url) {
        this.$message?.warning?.(this.$t('whatsapp.mediaDocsLinks.noData'))
        return
      }

      const ext = this.getFileExtFromNameOrUrl(target?.docName, url)
      if (this.isOfficePreviewableExt(ext)) {
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url),
          '_blank',
          'noopener'
        )
        return
      }

      window.open(url, '_blank', 'noopener')
    },
    handlePreviewLink(row) {
      const target = row || {}
      const text = String(target?.content || target?.url || target?.raw?.url || target?.raw?.text || '').trim()
      const url = this.normalizeLinkUrl(text)
      if (!url) {
        this.$message?.warning?.(this.$t('whatsapp.mediaDocsLinks.noData'))
        return
      }
      window.open(url, '_blank', 'noopener')
    },
    extractFirstHttpUrl(input) {
      const str = String(input || '')
      if (!str) return ''
      // 1) 优先提取带协议的 url
      const m1 = str.match(/https?:\/\/[\S]+/i)
      if (m1 && m1[0]) {
        return String(m1[0]).replace(/[),.，。；;]+$/g, '')
      }

      // 2) 兼容不带协议的域名形式（如 www.baidu.com / baidu.com/path）
      // 只允许 ascii 域名，避免中文/空格导致异常请求
      const m2 = str.match(/\b(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\/[\S]*)?/)
      if (m2 && m2[0]) {
        return String(m2[0]).replace(/[),.，。；;]+$/g, '')
      }

      return ''
    },
    parseHttpUrl(input) {
      try {
        const extracted = this.extractFirstHttpUrl(input)
        const candidate = extracted || input
        const normalized = this.normalizeLinkUrl(candidate)
        if (!normalized) return null
        const urlObj = new URL(normalized)
        if (urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:') return null
        const host = String(urlObj.hostname || '').trim()
        if (!host) return null
        if (/[\s]/.test(host)) return null
        if (!/^[a-zA-Z0-9.-]+$/.test(host)) return null
        return urlObj
      } catch {
        return null
      }
    },
    getFaviconUrl(url) {
      const urlObj = this.parseHttpUrl(url)
      if (!urlObj) return this.getFallbackFavicon()
      const host = String(urlObj.hostname || '')
      if (!host) return this.getFallbackFavicon()
      return `https://icons.duckduckgo.com/ip3/${host}.ico`
    },
    getFallbackFavicon() {
      return 'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23999%22%20stroke-width%3D%222%22%3E%3Cpath%20d%3D%22M10%2013a5%205%200%200%200%207.54.54l3-3a5%205%200%200%200-7.07-7.07l-1.72%201.71%22/%3E%3Cpath%20d%3D%22M14%2011a5%205%200%200%200-7.54-.54l-3%203a5%205%200%200%200%207.07%207.07l1.71-1.71%22/%3E%3C/svg%3E'
    },
    handleFaviconError(e) {
      const el = e?.target
      if (!el) return
      const fallback = this.getFallbackFavicon()
      if (el.src === fallback) return
      el.src = fallback
    },
    getLinkHost(url) {
      const urlObj = this.parseHttpUrl(url)
      return urlObj ? urlObj.hostname : ''
    },
    handlePreviewImage(row) {
      const src = row?.mediaUrl || row?.raw?.url || row?.raw?.extendUrl || ''
      if (!src) return
      viewerApi({
        images: [{ src }],
        options: {
          initialViewIndex: 0,
        },
      })
    },
    getRowId(row) {
      const r = row?.raw || row || {}
      return r?.id || r?._id || ''
    },
    getRowMessageId(row) {
      const r = row?.raw || row || {}
      return (
        r?.messageId ||
        r?.msgId ||
        r?.whatsAppMessageId ||
        r?.waMessageId ||
        r?.extendMessageId ||
        ''
      )
    },
    normalizeDownloadUrl(url) {
      const u = String(url || '').trim()
      if (!u) return ''
      return u.replace(/^http:\/\//i, 'https://')
    },
    getDownloadFileName(row) {
      const name = String(row?.mediaName || row?.docName || row?.content || '').trim()
      const rawUrl = row?.mediaUrl || row?.docUrl || row?.raw?.url || row?.raw?.extendUrl || row?.raw?.fileUrl || ''
      const url = String(rawUrl || '')
      const ext = this.getFileExtFromNameOrUrl(name, url)
      const hasExt = name && name.includes('.') && name.split('.').pop()
      if (name) {
        if (hasExt) return name
        if (ext) return `${name}.${ext}`
        return name
      }
      const ts = Date.now()
      return ext ? `attachment_${ts}.${ext}` : `attachment_${ts}`
    },
    async handleDeleteRow(row) {
      const id = this.getRowId(row)
      if (!id) {
        this.$message?.warning?.('缺少附件ID，无法删除')
        return
      }
      try {
        await ElMessageBox.confirm('确定要删除该附件吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'system-prompt-message-box'
        })
      } catch (e) {
        return
      }
      try {
        await deleteWhatsAppExtendBatch({ idList: [id] })
        this.$message?.success?.('删除成功')
        this.resetPagination()
        this.fetchList()
      } catch (e) {
        this.$message?.error?.('删除失败')
      }
    },
    handleForwardRow(row) {
      this.forwardRow = row || null
      this.$refs?.forwardMessage?.open?.(row?.raw || row)
    },
    async handleForwardSend(payload) {
      const done = typeof payload?.done === 'function' ? payload.done : null
      const contacts = Array.isArray(payload?.contacts) ? payload.contacts : []
      if (!contacts.length) {
        this.$message?.warning?.('请选择联系人')
        done && done(false)
        return
      }

      const extractMessageId = (res) => {
        try {
          const payload0 = res?.result || res?.data?.result || res?.data || res || {}
          return String(
            payload0?._data?.id?._serialized ||
            payload0?.id?._serialized ||
            payload0?._data?.id ||
            payload0?.messageId ||
            payload0?.id ||
            payload0?._id ||
            ''
          )
        } catch (e) {
          return ''
        }
      }

      const resolveUserInfo = () => {
        try {
          const userInfo = Storage.get('userInfo') || {}
          const systemUserId = userInfo?.id || userInfo?.userId
          const userId = systemUserId ? String(systemUserId) : ''
          
          // 优先读取账号特定的 WhatsApp 登录信息
          let waUser = {}
          if (userId) {
            waUser = Storage.get(`wa_login_user_${userId}`) || {}
          }
          // 如果没有账号特定缓存，再读取通用缓存（兼容旧数据）
          if (!waUser || !waUser.id) {
            waUser = Storage.get('wa_login_user') || {}
          }
          
          return {
            userId,
            userName: String(waUser?.name || waUser?.pushName || waUser?.username || '')
          }
        } catch (e) {
          return { userId: '', userName: '' }
        }
      }

      const inferExtendType = (tab, mimetype) => {
        if (tab === 'links') return 3
        if (tab === 'docs') return 2
        const mt = String(mimetype || '').toLowerCase()
        if (mt.startsWith('image/') || mt.startsWith('video/') || mt.startsWith('audio/')) return 1
        return 2
      }

      const row = this.forwardRow || null
      const raw = row?.raw || row || {}
      const url = String(row?.mediaUrl || row?.docUrl || raw?.url || raw?.extendUrl || raw?.fileUrl || raw?.path || raw?.text || '').trim()
      const text = String(raw?.text || raw?.url || row?.content || '').trim()
      const name = String(row?.mediaName || row?.docName || raw?.name || raw?.title || row?.content || '').trim()
      const rawMime = String(raw?.mimeType || raw?.contentType || raw?.type || '').trim()
      const mimetype = rawMime && rawMime.includes('/') ? rawMime : ''

      const hasUrl = !!url
      if (this.activeTab !== 'links' && !hasUrl) {
        this.$message?.warning?.('缺少附件链接，无法转发')
        done && done(false)
        return
      }
      if (this.activeTab === 'links' && !text) {
        this.$message?.warning?.('缺少链接内容，无法转发')
        done && done(false)
        return
      }

      const buildFilename = () => {
        const extFromUrl = () => {
          const u = String(url || '').split('?')[0].split('#')[0]
          const last = u.lastIndexOf('.')
          if (last === -1) return ''
          const ext = u.slice(last + 1)
          if (!ext || ext.includes('/') || ext.length > 10) return ''
          return ext
        }

        const ext = extFromUrl()
        if (name) {
          if (ext && !name.includes('.')) return `${name}.${ext}`
          return name
        }
        if (!url) return ext ? `file.${ext}` : 'file'
        const u = String(url).split('?')[0].split('#')[0]
        const last = u.lastIndexOf('/')
        const base = last > -1 ? u.slice(last + 1) : u
        return base || (ext ? `file.${ext}` : 'file')
      }

      const inferMimeFromUrl = () => {
        const u = String(url || '').split('?')[0].split('#')[0].toLowerCase()
        if (u.endsWith('.png')) return 'image/png'
        if (u.endsWith('.jpg') || u.endsWith('.jpeg')) return 'image/jpeg'
        if (u.endsWith('.gif')) return 'image/gif'
        if (u.endsWith('.webp')) return 'image/webp'
        if (u.endsWith('.bmp')) return 'image/bmp'
        if (u.endsWith('.svg')) return 'image/svg+xml'
        if (u.endsWith('.mp4')) return 'video/mp4'
        if (u.endsWith('.webm')) return 'video/webm'
        if (u.endsWith('.mov')) return 'video/quicktime'
        if (u.endsWith('.pdf')) return 'application/pdf'
        if (u.endsWith('.doc')) return 'application/msword'
        if (u.endsWith('.docx')) return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        if (u.endsWith('.xls')) return 'application/vnd.ms-excel'
        if (u.endsWith('.xlsx')) return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        if (u.endsWith('.ppt')) return 'application/vnd.ms-powerpoint'
        if (u.endsWith('.pptx')) return 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        if (u.endsWith('.csv')) return 'text/csv'
        if (u.endsWith('.txt')) return 'text/plain'
        if (u.endsWith('.zip')) return 'application/zip'
        if (u.endsWith('.rar')) return 'application/vnd.rar'
        return ''
      }

      const isImageByMime = () => {
        if (mimetype && mimetype.startsWith('image/')) return true
        const u = String(url).split('?')[0].split('#')[0].toLowerCase()
        return ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp', '.svg'].some((ext) => u.endsWith(ext))
      }

      const session = 'default'
      let ok = false
      try {
        const { userId, userName } = resolveUserInfo()
        const results = await Promise.all(
          contacts.map((c) => {
            const chatId = c?.id || c?.chatId
            if (!chatId) return Promise.resolve({ chatId: '', ok: false })

            if (this.activeTab === 'links') {
              const url0 = this.normalizeLinkUrl(text)
              const sendPromise = url0
                ? sendLinkCustomPreview({
                  chatId,
                  linkPreviewHighQuality: true,
                  preview: {
                    description: text,
                    title: url0,
                    url: url0,
                  },
                  session,
                  text,
                })
                : sendText({
                  chatId,
                  linkPreview: true,
                  linkPreviewHighQuality: false,
                  session,
                  text,
                })

              return sendPromise
                .then(async (res) => {
                  const messageId = extractMessageId(res)
                  if (!messageId) return { chatId, ok: false }
                  try {
                    await addWhatsAppExtend({
                      chatId: String(chatId || ''),
                      messageId,
                      name: text,
                      type: 3,
                      url: String(url0 || text || ''),
                      extendSize: 0,
                      userId,
                      userName,
                    })
                    return { chatId, ok: true }
                  } catch (e) {
                    this.$message?.warning?.(e?.message || '链接存储失败')
                    return { chatId, ok: false }
                  }
                })
                .catch(() => ({ chatId, ok: false }))
            }

            const filename = buildFilename()
            const inferredMime = mimetype || inferMimeFromUrl() || 'application/octet-stream'
            const apiCall = (inferredMime && inferredMime.startsWith('image/')) || isImageByMime() ? sendImage : sendFile
            return apiCall({
              caption: '',
              chatId,
              file: {
                filename,
                mimetype: inferredMime,
                url,
              },
              session,
            })
              .then(async (res) => {
                const messageId = extractMessageId(res)
                if (!messageId) return { chatId, ok: false }
                try {
                  await addWhatsAppExtend({
                    chatId: String(chatId || ''),
                    messageId,
                    name: String(filename || ''),
                    type: inferExtendType(this.activeTab, inferredMime),
                    url: String(url || ''),
                    extendSize: Number(raw?.extendSize || raw?.size || row?.extendSize || row?.size || 0),
                    userId,
                    userName,
                  })
                  return { chatId, ok: true }
                } catch (e) {
                  this.$message?.warning?.(e?.message || '附件存储失败')
                  return { chatId, ok: false }
                }
              })
              .catch(() => ({ chatId, ok: false }))
          })
        )
        const successCount = (results || []).filter((r) => r.ok).length
        const failCount = (results || []).length - successCount
        ok = successCount > 0
        if (successCount > 0 && failCount === 0) {
          this.$message?.success?.('转发成功')
        } else if (successCount > 0) {
          this.$message?.warning?.(`部分转发成功（成功 ${successCount}，失败 ${failCount}）`)
        } else {
          this.$message?.error?.('转发失败')
        }
      } finally {
        this.forwardRow = null
        done && done(ok)
      }
    },
    handleForwardClose() {
      this.forwardRow = null
    },
    async handleDownloadRow(row) {
      if (this.activeTab === 'links') return
      const rawUrl = row?.mediaUrl || row?.docUrl || row?.raw?.url || row?.raw?.extendUrl || row?.raw?.fileUrl || row?.raw?.path || ''
      const url = this.normalizeDownloadUrl(rawUrl)
      if (!url) {
        this.$message?.warning?.('下载链接为空')
        return
      }
      try {
        const res = await fetch(url)
        if (!res.ok) throw new Error(`HTTP status: ${res.status}`)
        const blob = await res.blob()
        downloadFile(blob, this.getDownloadFileName(row))
      } catch (e) {
        console.error('下载失败:', e)
        this.$message?.error?.('下载失败')
      }
    },
    headerClassName({row, column, rowIndex, columnIndex}) {
      const prop = column?.property || column?.prop
      return {
        'text-align': prop === 'content' ? 'left' : 'center',
        background: '#f9f9f9',
        color: 'black',
        padding: '8px 0px',
        fontSize: '13px',
        fontWeight: 'normal'
      }
    },
    resetPagination() {
      this.pageNo = 1
      this.total = 0
    },
    getTypeValue(tab) {
      const typeMap = {
        media: 1,
        docs: 2,
        links: 3
      }
      return typeMap[tab] || 1
    },
    normalizePayload(res) {
      const payload = res?.result || res?.data?.result || res?.data || res
      const list = payload?.records || payload?.list || payload?.rows || payload?.data || payload || []
      const total = payload?.total ?? payload?.count ?? payload?.totalCount ?? (Array.isArray(list) ? list.length : 0)
      return {
        list: Array.isArray(list) ? list : [],
        total: typeof total === 'number' ? total : Number(total || 0)
      }
    },
    formatTime(val) {
      if (!val) return ''
      const n = Number(val)
      const d = Number.isFinite(n) ? new Date(n) : new Date(val)
      if (Number.isNaN(d.getTime())) return ''
      const pad = (v) => String(v).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    resolveCurrentUser() {
      try {
        // 获取当前系统用户ID
        const userInfo = Storage.get('userInfo') || {}
        const systemUserId = userInfo?.id || userInfo?.userId
        const userId = systemUserId ? String(systemUserId) : ''
        
        // 优先读取账号特定的缓存
        let cached = {}
        if (userId) {
          cached = Storage.get(`wa_login_user_${userId}`) || {}
        }
        // 如果没有账号特定缓存，再读取通用缓存（兼容旧数据）
        if (!cached || !cached.id) {
          cached = Storage.get('wa_login_user') || {}
        }
        
        return {
          username: cached?.userName || cached?.name || cached?.pushName || '—',
          picture: cached?.picture || ''
        }
      } catch (e) {
        return { username: '—', picture: '' }
      }
    },
    mapItemToRow(item) {
      const it = item || {}
      const url = it?.url || it?.extendUrl || it?.fileUrl || it?.path || it?.link || ''
      const name = it?.name || it?.fileName || it?.title || ''
      const size = it?.extendSize || it?.size || ''
      const currentUser = this.resolveCurrentUser()

      const senderName = it?.userName ||it?.createByName || currentUser.username
      const senderPicCandidate = it?.picture
      const senderPic = (typeof senderPicCandidate === 'string' && senderPicCandidate.trim()) ? senderPicCandidate : defaultUserAvatar
      const senderTime = this.formatTime(it?.createTime || it?.updateTime || it?.timestamp)

      return {
        content: String(name || url || ''),
        description: String(size || it?.description || ''),
        mediaUrl: this.activeTab === 'media' ? String(url || '') : '',
        mediaName: this.activeTab === 'media' ? String(name || '') : '',
        docUrl: this.activeTab === 'docs' ? String(url || '') : '',
        docName: this.activeTab === 'docs' ? String(name || '') : '',
        sender: {
          username: String(senderName || '—'),
          picture: String(senderPic || ''),
          time: senderTime
        },
        raw: it
      }
    },
    async fetchList() {
      if (this.loading) return
      this.loading = true
      try {
        const params = {
          // chatId: this.chatId,
          type: this.getTypeValue(this.activeTab),
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          size: this.pageSize
        }
        // 非 allMode 且传了 chatId 时按 chatId 过滤
        if (!this.isAllMode && this.chatId) {
          params.chatId = this.chatId
        }

        const res = await getWhatsAppExtendList(params)
        const { list, total } = this.normalizePayload(res)
        this.total = total
        this.tableData = list.map((it) => this.mapItemToRow(it))
      } finally {
        this.loading = false
      }
    },
    handleCurrentChange(val) {
      this.page = Number(val) || 1
      this.fetchList()
    },
    handleDelete() {
      this.$emit('delete', { tab: this.activeTab })
    },
    handleForward() {
      this.$emit('forward', { tab: this.activeTab })
    },
    handleDownload() {
      this.$emit('download', { tab: this.activeTab })
    }
  }
}
</script>

<style lang="scss" scoped>
.media-docs-links-dialog {
  :deep(.el-dialog__body) {
    padding-top: 0;
  }
}

:deep(.media-docs-links-dialog-overlay) {
  z-index: 99 !important;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dialog-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.dialog-body {
  height: 100%;
  min-height: 0;
}

.dialog-body :deep(.media-docs-links-panel) {
  height: 100%;
}


.action-btn {
  width: 34px;
  height: 34px;
  border-radius: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 18px;
  color: #1890ff;
}

.username {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
	font-size: 13px;
  color: #444444;
}

.time {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #8A8A8F;
}

.table_box {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 20px;
  color: #444444;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.media-cell {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.media-thumb {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  object-fit: cover;
  cursor: pointer;
}

.media-url {
  max-width: 520px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.doc-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.doc-brief {
  display: flex;
  align-items: center;
  gap: 10px;
}

.doc-brief__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.doc-brief__text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}

.doc-brief__title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
	font-size: 13px;
  color: #444444;
  line-height: 20px;
  max-width: 520px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.doc-brief__sub {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #8A8A8F;
  line-height: 16px;
  max-width: 520px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.link-brief {
  display: flex;
  align-items: center;
  gap: 10px;
}

.link-brief__icon {
  width: 35px;
  height: 35px;
  border-radius: 8px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  .link-favicon {
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
}

.link-brief__text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}

.link-brief__title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
	font-size: 13px;
  color: #444444;
  line-height: 20px;
}

.link-brief__sub {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #8A8A8F;
  line-height: 16px;
  max-width: 520px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
